import store from "@/state/store";

export default [

 
  {
    path: "/",
    name: "default", 
    component: () => import("./views/dashboards/index"),
  }, 
  {
    path: '/:Sessionkey/:Email',
    name: 'sessiondefault',
    component: () => import("./views/dashboards/index"),
  },
  {
    path: '/forgotpassword/:code',
    name: 'forgotpassword', 
    component: () => import('./views/forgotpassword/index'), 
  },
  {
    path: "/oduyuru",
    name: "oduyuru", 
    component: () => import("./views/oduyuru/index"),
  }, 

  {
    path: "/otakvim",
    name: "otakvim", 
    component: () => import("./views/otakvim/index"),
  },  
  {
    path: "/oresmitatil",
    name: "oresmitatil",
    component: () => import("./views/oresmitatil/index"),
  },
  {
    path: "/oecampussenkron",
    name: "oecampussenkron",
    component: () => import("./views/oecampussenkron/index"),
  },
  
  
  {
    path: "/opersonel",
    name: "opersonel", 
    component: () => import("./views/opersonel/index"),
  },  
  {
    path: "/obirim",
    name: "obirim", 
    component: () => import("./views/obirim/index"),
  },   
  {
    path: "/tlptalep",
    name: "tlptalep", 
    component: () => import("./views/tlptalep/index"),
  },  
  {
    path: "/tlptalepamironay",
    name: "tlptalepamironay", 
    component: () => import("./views/tlptalepamironay/index"),
  },  
  {
    path: "/talepdetail/:Talepid",
    name: "talepdetail", 
    component: () => import("./views/tlptalep/detail"),
  },  
  {
    path: "/tlphavuz",
    name: "tlphavuz", 
    component: () => import("./views/tlptalep/havuz"),
  },  
  {
    path: "/tlpbirimtalep",
    name: "tlpbirimtalep", 
    component: () => import("./views/tlptalep/birim"),
  },  
  {
    path: "/tlptaleplerim",
    name: "tlptaleplerim", 
    component: () => import("./views/tlptalep/taleplerim"),
  },  
  {
    path: "/tlptalepolustur",
    name: "tlptalepolustur", 
    component: () => import("./views/tlptalep/talepolustur"),
  },  
  {
    path: "/editprofil",
    name: "editprofil", 
    component: () => import("./views/opersonel/editprofil"),
  },  
  {
    path: "/tlpemailtemplate",
    name: "tlpemailtemplate", 
    component: () => import("./views/tlpemailtemplate/index"),
  },  
  {
    path: "/atanantalepler",
    name: "atanantalepler", 
    component: () => import("./views/tlptalep/atanantalepler"),
  },  
  {
    path: "/tlphaziryanitlar",
    name: "tlphaziryanitlar", 
    component: () => import("./views/tlphaziryanitlar/index"),
  },  
  {
    path: "/bitistarihiyaklasan",
    name: "bitistarihiyaklasan", 
    component: () => import("./views/tlptalep/bitistarihiyaklasan"),
  },  
  {
    path: "/birimtaleplerim",
    name: "birimtaleplerim", 
    component: () => import("./views/tlptalep/birimtaleplerim"),
  },  
  {
    path: "/personeldurum",
    name: "personeldurum", 
    component: () => import("./views/tlprapor/personeldurum"),
  },  
  {
    path: "/birimdurum",
    name: "birimdurum", 
    component: () => import("./views/tlprapor/birimdurum"),
  }, 
  {
    path: "/talepdurum",
    name: "talepdurum", 
    component: () => import("./views/tlprapor/talepdurum"),
  }, 
  {
    path: "/personeltalep",
    name: "personeltalep", 
    component: () => import("./views/tlprapor/personeltalep"),
  },  
  {
    path: "/sendverificationemail/:userId/:code",
    name: "sendverificationemail", 
    component: () => import("./views/sendverificationemail/index"),
  },  
  {
    path: "/tlpplanrapor",
    name: "tlpplanrapor", 
    component: () => import("./views/tlpplanrapor/index"),
  },  
  
  {
    path: "/tlpplanraportakip",
    name: "tlpplanraportakip", 
    component: () => import("./views/tlpplanraportakip/index"),
  },  
  {
    path: "/tlptaleptahsilat",
    name: "tlptaleptahsilat", 
    component: () => import("./views/tlptaleptahsilat/index"),
  },  
  {
    path: "/osozlesme",
    name: "osozlesme", 
    component: () => import("./views/osozlesme/index"),
  },  
  
  {
    path: "/obirimbelge",
    name: "obirimbelge",
    component: () => import("./views/obirimbelge/index"),
  },

  {
    path: "/okurumgorusme",
    name: "okurumgorusme",
    component: () => import("./views/okurumgorusme/index"),
  },

  {
    path: "/okurumteklif",
    name: "okurumteklif",
    component: () => import("./views/okurumteklif/index"),
  },

  {
    path: "/kurumsozlesme",
    name: "kurumsozlesme", 
    component: () => import("./views/osozlesme/kurumsozlesme"),
  },  
  
   
  
  
  {
    path: '/login',
    name: 'login', 
    component: () => import('./views/login/index'), 
  },
  {
    path: '/logout',
    name: 'logout', 
    beforeEnter(to,from,next){  
    store.dispatch("auth/logOut") 
        next("/login") 
    }, 
  },
  {
    path: '/userroles',
    name: 'userroles', 
    component: () => import('./views/userroles/index'), 
  },
  {
    path: '/ouserbirimyetki',
    name: 'ouserbirimyetki', 
    component: () => import('./views/ouserbirimyetki/index'), 
  },
  {
    path: '/tlptalepbildirim',
    name: 'tlptalepbildirim', 
    component: () => import('./views/tlptalepbildirim/index'), 
  },
 
  
  
];